import { Hammer, Home, Layers, Upload } from "lucide-react";
import type { NavItem } from "../components/Navigation/Nav";

/** The app's main routes, used by templates that render their own header. */
export const defaultNavItems: readonly NavItem[] = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/build", label: "Builder", icon: Hammer },
  { to: "/import", label: "Import", icon: Upload },
  { to: "/deck", label: "Recent decks", icon: Layers },
];
